import { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useSuperAdmin } from '../contexts/SuperAdminContext';
import { 
  FaCrown, 
  FaTachometerAlt,
  FaUtensils, 
  FaChartLine, 
  
  FaFileAlt,
  FaCog,
  FaSignOutAlt
} from 'react-icons/fa';

// Import Super Admin Pages
import SuperAdminOverview from './super-admin/SuperAdminOverview';
import SuperAdminRestaurants from './super-admin/SuperAdminRestaurants';
import SuperAdminAnalytics from './super-admin/SuperAdminAnalytics';

import SuperAdminReports from './super-admin/SuperAdminReports';
import SuperAdminAccess from './super-admin/SuperAdminAccess';


const sidebarItems = [
  { name: 'Dashboard', icon: <FaTachometerAlt /> },
  { name: 'Restaurants', icon: <FaUtensils /> },
  { name: 'Analytics', icon: <FaChartLine /> },

  { name: 'Reports', icon: <FaFileAlt /> },
  { name: 'Access', icon: <FaCog /> },
];

export default function SuperAdminHome() {
  const [active, setActive] = useState('Dashboard');
  const { superAdmin, logout, loading: authLoading } = useSuperAdmin();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/super-admin/login');
    } catch (err) {
      console.error('Logout error:', err);
    }
  };
  
  const renderContent = () => {
    switch (active) {
      case 'Dashboard':
        return <SuperAdminOverview />;
      case 'Restaurants':
        return <SuperAdminRestaurants />;
      case 'Analytics':
        return <SuperAdminAnalytics />;
     
      case 'Reports':
        return <SuperAdminReports />;
      case 'Access':
        return <SuperAdminAccess />;
      default:
        return <SuperAdminOverview />;
    }
  };

  if (authLoading) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-400"></div>
      </div>
    );
  }

  if (!superAdmin) {
    navigate('/super-admin/login');
    return null; 
  }

  return (
    <div className="flex min-h-screen bg-gray-900 text-gray-200">
      {/* Sidebar */}
      <aside className="w-64 bg-gray-800 border-r border-gray-700 p-6 flex flex-col gap-4 h-screen sticky top-0 left-0">
        <div className="mb-8 flex items-center gap-3">
          <div className="w-10 h-10 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-lg flex items-center justify-center">
            <FaCrown className="text-white text-lg" />
          </div>
          <h1 className="text-xl font-bold text-white">Super Admin</h1>
        </div>
        
        {sidebarItems.map(item => (
          <button
            key={item.name}
            className={`flex items-center gap-3 px-4 py-2 rounded-lg text-base font-medium transition ${
              active === item.name 
              ? 'bg-purple-600 text-white' 
              : 'text-gray-400 hover:bg-gray-700 hover:text-white'
            }`}
            onClick={() => setActive(item.name)}
          >
            <span className="text-xl">{item.icon}</span> {item.name}
          </button>
        ))}

        <div className="mt-auto">
          
          {/* TEMPORARY: Button to print super admin ID token */}
          {/* <button
            onClick={async () => {
              const { auth } = await import('../utils/firebase');
              if (auth.currentUser) {
                auth.currentUser.getIdToken().then(token => {
                  console.log('SUPER_ADMIN_TOKEN:', token);
                  alert('Token printed to console!');
                });
              } else {
                alert('No user logged in!');
              }
            }}
            className="flex w-full items-center gap-3 px-4 py-2 rounded-lg text-base font-medium transition bg-blue-800 text-blue-100 hover:bg-blue-700 mb-2"
          >
            Print ID Token (TEMP)
          </button> */}
          <button
            onClick={handleLogout}
            className="flex w-full items-center gap-3 px-4 py-2 rounded-lg text-base font-medium transition bg-red-800 text-red-100 hover:bg-red-700"
          >
            <FaSignOutAlt /> Logout
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 p-10 overflow-y-auto h-screen">
        <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
        >
          {renderContent()}
        </motion.div>
      </main>
    </div>
  );
} 